import airports from 'airport-timezone' with { type: 'json' }

export default function airportTimezone (airportCode) {
  const match = airports.find(airport => airport.code === airportCode)
  if (!match) {
    throw new Error('airport not found: ' + airportCode)
  }
  return match.timezone
}
